import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import UserLogin from "./Forms/UserLogin";
import AccountOwnerLogin from "./Forms/AccountOwnerLogin";
import { ErrorLabel, AuthDescription, AuthOption, AuthOptionDescription, AuthOptionIndicator, AuthOptionTitle, AuthPrimaryButton, AuthSurface, AuthTitle } from "src/components";

export const ErrorStrings = {
    UNKNOWN_ERROR: "* An unknown error occurred.",
    EMPTY_ACCESS_TOKEN: "* Please enter an access token.",
    EMPTY_PASSWORD: "* Please enter a password.",
    EMPTY_EMAIL: "* Please enter an email address."
};

const Login = (props) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [tabShown, setTabShown] = useState(null);
    const status = new URLSearchParams(useLocation().search).get("status");

    const showLoginSelection = () => {
        setTabShown(null);
        setSelectedOption(null);
    };

    if (tabShown === "user") {
        return <UserLogin loginSuccess={props.login} showLoginSelection={showLoginSelection} />;
    }

    if (tabShown === "account") {
        return <AccountOwnerLogin loginSuccess={props.login} showLoginSelection={showLoginSelection} />;
    }

    return (
        <AuthSurface>
            <AuthTitle>Log In</AuthTitle>
            <AuthDescription>Choose the account type you use to access the Business Portal.</AuthDescription>
            <ErrorLabel height="1.3rem" margin="0 0 .75rem" align="center">
                {status === "invalidToken" ? "Your token in this device has expired. Please login again." : ""}
            </ErrorLabel>
            <div style={{ display: "grid", gap: "0.75rem" }}>
                <AuthOption type="button" $selected={selectedOption === "account"} onClick={() => setSelectedOption("account")}>
                    <AuthOptionIndicator $selected={selectedOption === "account"} />
                    <span><AuthOptionTitle>Account Owner</AuthOptionTitle><AuthOptionDescription>Account owner that performs tasks requiring unrestricted access.</AuthOptionDescription></span>
                </AuthOption>
                <AuthOption type="button" $selected={selectedOption === "user"} onClick={() => setSelectedOption("user")}>
                    <AuthOptionIndicator $selected={selectedOption === "user"} />
                    <span><AuthOptionTitle>User</AuthOptionTitle><AuthOptionDescription>User with assigned Me Business permissions and access.</AuthOptionDescription></span>
                </AuthOption>
            </div>
            <AuthPrimaryButton disabled={!selectedOption} onClick={() => setTabShown(selectedOption)}>Continue</AuthPrimaryButton>
        </AuthSurface>
    );
};

export default Login;
